import { postReq } from "../apis/internalApi";
import { API, MIXPANEL_EVENTS } from "../constants/index";
import axios from "axios";
import ReactGA from "react-ga4";
const getIp = async () => {
  const res = await axios.get("https://geolocation-db.com/json/");
  return res.data.IPv4;
};

export const createMixpanelUser = async () => {
  const ip = await getIp();
  const response = await postReq(API.MIXPANEL, "user_create", "", { ip });
  return response.data;
};

export const trackEvent = async (label = "", params = {}) => {
  try {
    ReactGA.event({
      action: 'scheduled_discovery',
      category: 'engagement',
      label: label,
      value: 1546
    });

  } catch (error) {
    console.error(error)
  }

};

export const trackLogin = async () => {
  ReactGA.event({
    action: 'login',
    category: 'engagement',
    label: 'login'
  });
}

export const mixpanelIncrement = async (mixpanelId, params) => {
  const response = await postReq(API.MIXPANEL, "increment", "", {
    mixpanel_id: mixpanelId,
    params,
  });
  return response.data;
};

//events

export const handleMixpanelPageView = async (page, isPublic, mixpanelId) => {
  trackEvent(MIXPANEL_EVENTS.PAGE_VIEW, {
    distinct_id: mixpanelId,
    page,
    is_public: isPublic,
  });
  if (isPublic) {
    mixpanelIncrement(mixpanelId, "public_page_views");
  }
};
